/*
 | -------------------------------------------------------------
 |  --> type: app
 |  --> name: import partials
 |  --> version: 1.1.0
 | -------------------------------------------------------------
 |
 |  This file imports and organizes all partials from the scss
 |  folder.
 |
*/

// import polyfills
import 'element-closest-polyfill'

// import component modules
import './components/accordion'
import './components/cookie-notice'
import './components/datatables'
import './components/dropdown'
import './components/form-errors'
import './components/modal'
import './components/navigation-breadcrumbs'
import './components/navigation-dropdown'
import './components/navigation-main'
import './components/navigation-skip-links'
import './components/navigation-tabs'
import './components/navigation-top'
import './components/pro6pp'
import './components/responsive-toggler'
import './components/toggle-card'
import './components/upload-input'

// normalize button clicks between browsers
document.addEventListener('click', event => {
  if (event.target.matches('button')) {
    event.target.focus()
  }
})

// focus on me
const focusOnMe = document.querySelector('[data-focus-on-me]')
if (focusOnMe) {
  focusOnMe.setAttribute('tabindex', '-1')
  focusOnMe.focus()
}
